import {
    ChangeEvent,
    Dispatch,
    SetStateAction,
    useEffect,
    useState,
} from "react";
import { Col, Row } from "react-bootstrap";
import uuid from "react-uuid";
import Professor from "../model/dto/Professor";

import {
    StyledContainerActions,
    StyledPaginationContainer,
    StyledTableAssociation,
    StyledTitle,
} from "../styles/components/AssociationComponentStyles";
import ButtonStyles from "../styles/components/ButtonStyles";
import {
    StyledFormCheck,
    StyledFormControlSearch,
    StyledInputGroupSearch,
    StyledInputGroupTextSearch,
} from "../styles/MainStyles";
import { SearchIcon } from "./Icons";
import PaginationLocal from "./PaginationLocal";

const { BtnPrimary, BtnOutlinePrimary } = ButtonStyles;

interface AssociationComponentProps {
    association: any[];
    linked: any[];
    title: string;
    titleSecond: string;
    onClick: (params: any[]) => void;
    setAddRemove: Dispatch<SetStateAction<string>>;
    isSave: boolean;
    setIsSave: Dispatch<SetStateAction<boolean>>;
    validLinked?: string;
}

function AssociationComponent({
    association,
    linked,
    title,
    titleSecond,
    onClick,
    setAddRemove,
    isSave,
    setIsSave,
    validLinked,
}: AssociationComponentProps) {
    const [first, setFirst] = useState<any[]>([]);
    const [second, setSecond] = useState<Array<Professor>>([]);
    // Filter
    const [searchFirst, setSearchFirst] = useState("");
    const [searchSecond, setSearchSecond] = useState("");
    const [filteredFirst, setFilteredFirst] = useState<any[]>([]);
    const [filteredSecond, setFilteredSecond] = useState<any[]>([]);
    // Check
    const [checkFirst, setCheckFirst] = useState<any[]>([]);
    const [checkSecond, setCheckSecond] = useState<any[]>([]);
    const [checkAllFirst, setCheckAllFirst] = useState(false);
    const [checkAllSecond, setCheckAllSecond] = useState(false);
    // Pagination
    const [pageFirst, setPageFirst] = useState<any[]>([]);
    const [pageSecond, setPageSecond] = useState<any[]>([]);

    const handleSortList = (list: any[]) => {
        return list.sort((a, b) => a.nome.localeCompare(b.nome));
    };

    const handleFilterList = (list: any[], seach: string) => {
        return list.filter(
            (item) =>
                item?.nome?.toLowerCase().includes(seach?.toLowerCase()) ||
                item?.matriculaADP
                    ?.toLowerCase()
                    ?.includes(seach?.toLowerCase())
        );
    };

    const handleFirstCheck = (event: any) => {
        first.forEach((item) => {
            if (item.docenteID.toString() === event.target.id) {
                setCheckFirst([...checkFirst, item]);
            }
        });
        if (!event.target.checked) {
            setCheckFirst(
                checkFirst.filter(
                    (item) => item.docenteID.toString() !== event.target.id
                )
            );
        }
    };

    const handleSecondCheck = (event: any) => {
        second.forEach((item) => {
            if (item.docenteID?.toString() === event.target.id) {
                setCheckSecond([...checkSecond, item]);
            }
        });
        if (!event.target.checked) {
            setCheckSecond(
                checkSecond.filter(
                    (item) => item.docenteID.toString() !== event.target.id
                )
            );
        }
    };

    const handleCheckAllFirst = () => {
        setCheckAllFirst(!checkAllFirst);
        setCheckFirst(filteredFirst);
        if (checkAllFirst) {
            setCheckFirst([]);
        }
    };

    const handleCheckAllSecond = () => {
        setCheckAllSecond(!checkAllSecond);
        setCheckSecond(
            filteredSecond.filter((item) => item.coordenadorVinculo !== "N")
        );
        if (checkAllSecond) {
            setCheckSecond([]);
        }
    };

    const handleSearchFirstChange = (
        event: ChangeEvent<{ value: unknown }>
    ) => {
        const value = event.target.value as string;
        if (value.length < searchFirst.length) {
            setCheckAllFirst(false);
            setCheckFirst([]);
        }
        setSearchFirst(value);
    };

    const handleSearchSecondChange = (
        event: ChangeEvent<{ value: unknown }>
    ) => {
        const value = event.target.value as string;
        if (value.length < searchSecond.length) {
            setCheckAllSecond(false);
            setCheckSecond([]);
        }
        setSearchSecond(value);
    };

    const handleSave = () => {
        onClick(second.filter((item) => item.matriculaAdp !== validLinked));
    };

    const handleClickAdd = () => {
        setFirst(first.filter((item) => !checkFirst.includes(item)));
        setSecond(second.concat(checkFirst));
        setCheckFirst([]);
        setCheckSecond([]);
        setCheckAllFirst(false);
        setCheckAllSecond(false);
        setIsSave(true);
        setAddRemove("add");
    };

    const handleClickRemove = () => {
        setFirst(first.concat(checkSecond));
        setSecond(second.filter((item) => !checkSecond.includes(item)));
        setCheckFirst([]);
        setCheckSecond([]);
        setCheckAllFirst(false);
        setCheckAllSecond(false);
        setIsSave(true);
        setAddRemove("remove");
    };

    useEffect(() => {
        if (linked) setSecond(linked);
        if (linked && association)
            setFirst(
                association.filter(
                    (items) =>
                        !linked.some(
                            (item) =>
                                item.matriculaAdp.toLowerCase() ===
                                items.matriculaAdp.toLowerCase()
                        )
                )
            );
    }, [association, linked]);

    useEffect(() => {
        if (first) {
            setFirst(handleSortList(first));
            setFilteredFirst(handleFilterList(first, searchFirst));
        }
        if (second) {
            setSecond(handleSortList(second));
            setFilteredSecond(handleFilterList(second, searchSecond));
        }
    }, [first, second]);

    useEffect(() => {
        setFilteredFirst(handleFilterList(first, searchFirst));
        setFilteredSecond(handleFilterList(second, searchSecond));
    }, [searchFirst, searchSecond]);

    const btnSave = (
        <div
            className="mt-3 d-flex justify-content-end"
            style={{ textAlign: "end" }}
        >
            <BtnPrimary onClick={handleSave} disabled={!isSave}>
                Salvar
            </BtnPrimary>
        </div>
    );

    return (
        <Row className="mt-1 pe-4">
            <Col xs="12" lg="5">
                <StyledTableAssociation
                    striped={pageFirst?.length > 0}
                    bordered
                    responsive
                >
                    <thead style={{ borderWidth: "1px" }}>
                        <tr>
                            <th>
                                <StyledFormCheck
                                    type="checkbox"
                                    checked={checkAllFirst}
                                    onChange={handleCheckAllFirst}
                                    disabled={!pageFirst.length}
                                />
                            </th>
                            <th className="d-fex">
                                <Row className="align-items-center justify-content-center align-middle">
                                    <Col>
                                        <StyledTitle>{title}</StyledTitle>
                                    </Col>
                                    <Col>
                                        <StyledInputGroupSearch>
                                            <StyledInputGroupTextSearch>
                                                <SearchIcon />
                                            </StyledInputGroupTextSearch>
                                            <StyledFormControlSearch
                                                type="text"
                                                placeholder="Pesquise aqui"
                                                value={searchFirst}
                                                onChange={
                                                    handleSearchFirstChange
                                                }
                                            />
                                        </StyledInputGroupSearch>
                                    </Col>
                                </Row>
                            </th>
                        </tr>
                    </thead>
                    <tbody style={{ borderWidth: "1px", background: "none" }}>
                        {pageFirst?.length === 0 ? (
                            <tr key={uuid()} className="table-empty">
                                <td colSpan={2}>
                                    {first.length
                                        ? "Nenhum resultado encontrado."
                                        : "Nenhum professor disponível."}
                                </td>
                            </tr>
                        ) : (
                            pageFirst.map((item) => (
                                <tr key={item?.matriculaADP}>
                                    <td style={{ borderWidth: "0px" }}>
                                        <StyledFormCheck
                                            type="checkbox"
                                            id={item.docenteID}
                                            checked={checkFirst.includes(item)}
                                            onChange={handleFirstCheck}
                                        />
                                    </td>
                                    <td style={{ borderWidth: "0px" }}>
                                        {item?.nome || ""} -{" "}
                                        {item?.matriculaAdp}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </StyledTableAssociation>
                <StyledPaginationContainer
                    className={filteredFirst?.length <= 10 ? "invisible" : ""}
                >
                    <PaginationLocal
                        items={filteredFirst}
                        itemsPage={10}
                        onPaginate={(items) => setPageFirst(items)}
                    />
                </StyledPaginationContainer>
            </Col>
            <Col>
                <StyledContainerActions>
                    <BtnOutlinePrimary
                        disabled={checkFirst.length === 0}
                        onClick={handleClickAdd}
                    >
                        Adicionar
                    </BtnOutlinePrimary>
                    <BtnOutlinePrimary
                        disabled={checkSecond.length === 0}
                        onClick={handleClickRemove}
                    >
                        Remover
                    </BtnOutlinePrimary>
                </StyledContainerActions>
            </Col>
            <Col xs="12" lg="5">
                <StyledTableAssociation
                    striped={pageSecond?.length > 0}
                    bordered
                    responsive
                >
                    <thead style={{ borderWidth: "1px" }}>
                        <tr>
                            <th>
                                <StyledFormCheck
                                    type="checkbox"
                                    checked={checkAllSecond}
                                    onChange={handleCheckAllSecond}
                                    disabled={!pageSecond.length}
                                />
                            </th>
                            <th className="d-fex">
                                <Row className="align-items-center justify-content-center align-middle">
                                    <Col>
                                        <StyledTitle>{titleSecond}</StyledTitle>
                                    </Col>
                                    <Col className="align-items-center justify-content-center">
                                        <StyledInputGroupSearch>
                                            <StyledInputGroupTextSearch>
                                                <SearchIcon />
                                            </StyledInputGroupTextSearch>
                                            <StyledFormControlSearch
                                                type="text"
                                                placeholder="Pesquise aqui"
                                                value={searchSecond}
                                                onChange={
                                                    handleSearchSecondChange
                                                }
                                            />
                                        </StyledInputGroupSearch>
                                    </Col>
                                </Row>
                            </th>
                        </tr>
                    </thead>
                    <tbody
                        key={uuid()}
                        style={{ borderWidth: "1px", background: "none" }}
                    >
                        {pageSecond?.length === 0 ? (
                            <tr key={uuid()} className="table-empty">
                                <td colSpan={2}>
                                    {second.length
                                        ? "Nenhum resultado encontrado."
                                        : "Você ainda não fez nenhuma atribuição."}
                                </td>
                            </tr>
                        ) : (
                            pageSecond.map((item) => (
                                <tr key={item?.matriculaADP}>
                                    <td style={{ borderWidth: "0px" }}>
                                        <StyledFormCheck
                                            type="checkbox"
                                            id={item.docenteID}
                                            checked={checkSecond.includes(item)}
                                            onChange={handleSecondCheck}
                                            disabled={
                                                item.coordenadorVinculo === "N"
                                            }
                                        />
                                    </td>
                                    <td style={{ borderWidth: "0px" }}>
                                        {item?.nome || ""} -{" "}
                                        {item?.matriculaAdp}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </StyledTableAssociation>
                {filteredSecond?.length <= 10 && btnSave}
                <StyledPaginationContainer
                    className={filteredSecond?.length <= 10 ? "invisible" : ""}
                >
                    <PaginationLocal
                        items={filteredSecond}
                        itemsPage={10}
                        onPaginate={(items) => setPageSecond(items)}
                    />
                </StyledPaginationContainer>
                {filteredSecond?.length > 10 && btnSave}
            </Col>
        </Row>
    );
}

export default AssociationComponent;
